import { z } from "zod"

export const betterDocReferralSlipSchema = z
  .object({
    startDate: z.date({ error: "admin.betterDoc.referralSlipDialog.startDateRequired" }),
    endDate: z.date({ error: "admin.betterDoc.referralSlipDialog.endDateRequired" }),
  })
  .refine(({ startDate, endDate }) => endDate >= startDate, {
    message: "admin.betterDoc.referralSlipDialog.endBeforeStart",
    path: ["endDate"],
  })

export type BetterDocReferralSlipSchema = z.infer<typeof betterDocReferralSlipSchema>
